<template>
  <div class="title">
    <div class="tag">
    </div>
      {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    default: () => {
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
  .title {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
    display: flex;
    align-items: center;
    padding-top: 8px;
    padding-bottom: 8px;

    .tag {
      width: 5px;
      height: 16px;
      background: #1890FF;
      margin-right: 8px;
    }
  }

</style>
